import React from 'react';
import './FlightResults.css';

/**
 * FlightResults - Simple clean flight cards like SanoGrid
 */
const FlightResults = ({ flights, loading, error, onSelectFlight, flightType = "Outbound" }) => {
  
  if (loading) {
    return (
      <div className="simple-results-loading">
        <div className="loading-spinner"></div>
        <p>Searching flights...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="simple-results-error">
        <p>{error}</p>
      </div>
    );
  }

  if (!flights || flights.length === 0) {
    return (
      <div className="simple-results-empty">
        <p>No flights found</p>
      </div>
    );
  }

  const formatTime = (dateTime) => {
    if (!dateTime) return 'N/A';
    const date = new Date(dateTime);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const formatDuration = (duration) => {
    if (!duration) return '';
    const match = duration.match(/PT(\d+)H(\d+)M/);
    if (!match) return duration;
    return `${match[1]}h ${match[2]}m`;
  };

  return (
    <div className="simple-flight-results">
      <div className="results-header-simple">
        <h2>{flightType} Flights</h2>
        <p>{flights.length} flights • {flights[0]?.origin} → {flights[0]?.destination}</p>
      </div>

      <div className="flight-cards-simple">
        {flights.map((flight, index) => (
          <div key={flight.id || index} className="flight-card-simple">
            <div className="flight-card-left">
              {/* Airline */}
              <div className="airline-badge">
                {flight.airlineCode || flight.carrierCode}
              </div>

              {/* Flight Number */}
              <div className="flight-number-small">
                {flight.flightNumber}
              </div>
            </div>

            <div className="flight-card-center">
              {/* Times and Route */}
              <div className="flight-route-simple">
                <div className="time-point">
                  <div className="flight-time-large">{formatTime(flight.departureTime)}</div>
                  <div className="airport-code-small">{flight.origin}</div>
                </div>

                <div className="flight-duration-middle">
                  <div className="duration-text-small">{formatDuration(flight.duration)}</div>
                  <div className="duration-line-simple">
                    <div className="line-dot"></div>
                    <div className="line-bar"></div>
                    <div className="line-dot"></div>
                  </div>
                  <div className="stops-text-small">
                    {flight.stops === 0 ? 'Direct' : `${flight.stops} stop`}
                  </div>
                </div>

                <div className="time-point">
                  <div className="flight-time-large">{formatTime(flight.arrivalTime)}</div>
                  <div className="airport-code-small">{flight.destination}</div>
                </div>
              </div>

              {/* Additional Info */}
              <div className="flight-info-row">
                <span className="info-badge">{flight.airline || flight.carrierCode}</span>
                <span className="info-badge">{flight.travelClass || 'ECONOMY'}</span>
              </div>
            </div>

            <div className="flight-card-right">
              {/* Price */}
              <div className="price-section">
                <div className="price-label-small">per person</div>
                <div className="price-amount-large">${flight.price}</div>
              </div>

              {/* Action Button */}
              <button
                className="add-trip-button"
                onClick={() => onSelectFlight && onSelectFlight(flight)}
              >
                Add to Trip
              </button>

              {flight.bookingUrl && (
                <a 
                  href={flight.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="book-direct-link-small"
                >
                  Book Direct
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlightResults;